import Rails from "@rails/ujs";
import * as Turbo from "@hotwired/turbo";
import "trix";
import "@rails/actiontext";

import "../base";
import "../components";

const images = import.meta.glob("../images/**/*", { eager: true });

if (!window._rails_loaded) Rails.start();
Turbo.start();
